// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ajuste{
    margin-left: 5px;
}

.centrar-pantalla{
    margin: 0 auto;
    width: 450px;
    margin-top: 10%px;
}

.alertOnline{
    transition: all 1s ease;
}

.online{
    z-index: 10000;
    position: fixed;
    text-align: center;
    width: 100%;
    top:0;
}

.navMenu{
  
}`, "",{"version":3,"sources":["webpack://./src/app/pages/test-nav/test-nav.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,KAAK;AACT;;AAEA;;AAEA","sourcesContent":[".ajuste{\r\n    margin-left: 5px;\r\n}\r\n\r\n.centrar-pantalla{\r\n    margin: 0 auto;\r\n    width: 450px;\r\n    margin-top: 10%px;\r\n}\r\n\r\n.alertOnline{\r\n    transition: all 1s ease;\r\n}\r\n\r\n.online{\r\n    z-index: 10000;\r\n    position: fixed;\r\n    text-align: center;\r\n    width: 100%;\r\n    top:0;\r\n}\r\n\r\n.navMenu{\r\n  \r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
